import styled from "styled-components";
import Colors from "../../themes/Colors";



const CardTotalSpotsHolder = styled.div`
  .cardGeneral {
    position: static;
    z-index: 996;
    height: auto;
    background-color: ${Colors.primary};
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
    padding: 10px;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    color: ${Colors.onPrimary};
    float: none;
    margin: 0;
    min-width: 0;

    @media only screen and (max-width: 1400px) {
      .impacts-container {
        line-height: 20px;
      }
    }
  }
  .infoTotalSpots {
    margin-bottom: 5px;
    font-size: 13px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: ${Colors.onPrimarySoft};
  }
  .totalSpotsContainer {
    background-color: ${Colors.snow};
    border-radius: 8px;
    padding: 3px 6px;
    margin-right: 0;
   }
   .totalSpots {
    margin: 0;
    color: ${Colors.primaryAccent};
    font-weight: 500;
    text-align: center;
   }
`;

export default CardTotalSpotsHolder;